import LtsLayout from 'src/onboarding/layouts/lts';

// import AnalysisLayout from './layouts/analysis/layout';
import AnalyzingAnswersPage from './pages/analyzing-answers/page';
// import AnalysisPage from './pages/analysis/page';
// import WebUpsale from './pages/webUpsale';
import WebUpsaleFirst from './pages/webUpsale/components/WebUpsaleFirst';
// import WebUpsaleSecond from './pages/webUpsale/components/WebUpsaleSecond';
import WebUpsaleThird from './pages/webUpsale/components/WebUpsaleThird';
import WebUpsaleFourth from './pages/webUpsale/components/WebUpsaleFourth';
import WebUpsaleFifth from './pages/webUpsale/components/WebUpsaleFifth';
import TermsOfUse from './pages/terms-of-use';
import PrivacyPolicy from './pages/privacy-policy';
import LegalLayout from './layouts/legal';

import GenderPage from "./pages/gender"
import BornPage from "./pages/born"
import NamePage from "./pages/name"
import HeightPage from "./pages/height"
import WeightPage from "./pages/weight"
import TransitionFirst from "./pages/transition/transitionFirst"
import WhenPage from "./pages/when"
import EmailPage from "./pages/email"
import EmailAfterPaymentPage from "./pages/email-after-payment"
import TransitionSecond from "./pages/transition/transitionSecond"
import LtsvPhotoExamplePage from "./pages/lts-photo-example"
import TransitionThird from "./pages/transition/transitionThird"
import TransitionFourth from "./pages/transition/transitionFourth"
import TransitionSeventh from "./pages/transition/transitionSeventh"
import LtsResultPage from "./pages/lts-result"
import PersonalPlanPage from "./pages/personal-plan/index"
import WebUpsaleThirdNew from "./pages/web-upsale/webUpsaleThird"
import WebUpsaleFourthNew from "./pages/web-upsale/webUpsaleFourth"
import MainLayout from "./layouts/main/layout";
import TransitionLayout from "./layouts/transition";
import HairstyleLayout from "./layouts/hairstyle/layout";
import HairstyleWomenLayout from "./layouts/hairstyle-women/layout";
import AdditionalGoalsPage from './pages/additional-goals'
import TransitionFifth from './pages/transition/transitionFifth';
import TransitionSixth from './pages/transition/transitionSixth'
import TransitionEighth from './pages/transition/transitionEighth';
import AlmostDonePage from './pages/almost-done'
import BirthDatePage from './pages/birth-date'
import AnalyzeBodyPage from './pages/analyze-body'
import FullBodyPhotoPage from './pages/full-body-photo'
import BeforeAfterPage from './pages/before-after';
import UpsaleWithoutTrial from './pages/webUpsale/components/UpsaleWithoutTrial';
import TakePicturesPage from './pages/take-pictures';
import TrialPricePage from './pages/trial-price';

import PrelandPage from './pages/preland';

import PersonalPlanSecond from './pages/personal-plan-2';
import EmailSecond from './pages/email-2';

import BestApp from './pages/best-app';

import WeightChange from './pages/weight-change';

import Analyzing from './pages/analyzing';
import AnalyzingSecond from './pages/analyzing';
import AnalyzingThird from './pages/analyzing';
import AnalyzingFourth from './pages/analyzing';

import PersonalPlanThird from './pages/personal-plan-3';

import AnalyzingBody from './pages/analyzing-body';

import AnalyzingActivity from './pages/analyzing-activity';

import PersonalPlanFourth from './pages/personal-plan-4';

import ActivityPlan from './pages/activity-plan'

import Barriers from './pages/barriers';

import PersonalPlanMetabolism from './pages/personal-plan-metabolism';
import UpsaleNutritionBundle from './pages/webUpsale/components/upsale-nutrition-bundle';

import UpsaleDynamic from './pages/upsale-dynamic';
import PersonalPlanDynamic from './pages/dynamic-personal-plan';

import FaceScanPhoto from './pages/face-scan';
import FaceScanAnimation from './pages/face-scan-animation';
import FaceScanId from './pages/face-scan-id';

import PaywallPage from './pages/paywall';

//hairstyle-quiz
import HairstyleHero from './pages/hairstyle-quiz/hairstyle-hero';
import HairstyleWonder from './pages/hairstyle-quiz/hairstyle-wonder';
import HairstyleHoldingBack from './pages/hairstyle-quiz/hairstyle-holding-back';
import HairstyleImprove from './pages/hairstyle-quiz/hairstyle-improve';
import HairstyleValue from './pages/hairstyle-quiz/hairstyle-value';
import HairstyleStyleLike from './pages/hairstyle-quiz/hairstyle-style-like';
import HairstyleFaceShape from './pages/hairstyle-quiz/hairstyle-face-shape';
import HairstyleHairTexture from './pages/hairstyle-quiz/hairstyle-hair-texture';
import HairstyleHairColor from './pages/hairstyle-quiz/hairstyle-hair-color';
import HairstyleSocialProof from './pages/hairstyle-quiz/hairstyle-social-proof';
import HairstyleStylingEffort from './pages/hairstyle-quiz/hairstyle-styling-effort';
import HairstyleHairThickness from './pages/hairstyle-quiz/hairstyle-hair-thickness';
import HairstyleWashFrequency from './pages/hairstyle-quiz/hairstyle-wash-frequency';
import HairstyleChangeFrequency from './pages/hairstyle-quiz/hairstyle-change-frequency';
import HairstyleWouldTry from './pages/hairstyle-quiz/hairstyle-would-try';
import HairstyleStylingProducts from './pages/hairstyle-quiz/hairstyle-styling-products';
import HairstyleHasBarber from './pages/hairstyle-quiz/hairstyle-has-barber';
import HairstyleBarberStruggle from './pages/hairstyle-quiz/hairstyle-barber-struggle';
import HairstyleInfo from './pages/hairstyle-quiz/hairstyle-info';
import HairstyleHappiestResult from './pages/hairstyle-quiz/hairstyle-happiest-result';
import HairstylePhotoRules from './pages/hairstyle-quiz/hairstyle-photo-rules';
import HairstylePhoto from './pages/hairstyle-quiz/hairstyle-photo';
import HairstyleAnalysis from './pages/hairstyle-quiz/hairstyle-analysis';
import HairstyleBeforeAfter from './pages/hairstyle-quiz/hairstyle-before-after';
import HairstylePaywall from './pages/hairstyle-quiz/hairstyle-paywall';
import HairstyleSuccess from './pages/hairstyle-quiz/hairstyle-success';
import HairstyleUpsale from './pages/hairstyle-quiz/hairstyle-upsale';
//hairstyle-women-quiz
import HairstyleWomenHero from './pages/hairstyle-women-quiz/hairstyle-women-hero';
import HairstyleWomenWonder from './pages/hairstyle-women-quiz/hairstyle-women-wonder';
import HairstyleWomenHoldingBack from './pages/hairstyle-women-quiz/hairstyle-women-holding-back';
import HairstyleWomenImprove from './pages/hairstyle-women-quiz/hairstyle-women-improve';
import HairstyleWomenValue from './pages/hairstyle-women-quiz/hairstyle-women-value';
import HairstyleWomenStyleLike from './pages/hairstyle-women-quiz/hairstyle-women-style-like';
import HairstyleWomenFaceShape from './pages/hairstyle-women-quiz/hairstyle-women-face-shape';
import HairstyleWomenHairTexture from './pages/hairstyle-women-quiz/hairstyle-women-hair-texture';
import HairstyleWomenHairColor from './pages/hairstyle-women-quiz/hairstyle-women-hair-color';
import HairstyleWomenSocialProof from './pages/hairstyle-women-quiz/hairstyle-women-social-proof';
import HairstyleWomenStylingEffort from './pages/hairstyle-women-quiz/hairstyle-women-styling-effort';
import HairstyleWomenHairThickness from './pages/hairstyle-women-quiz/hairstyle-women-hair-thickness';
import HairstyleWomenWashFrequency from './pages/hairstyle-women-quiz/hairstyle-women-wash-frequency';
import HairstyleWomenChangeFrequency from './pages/hairstyle-women-quiz/hairstyle-women-change-frequency';
import HairstyleWomenWouldTry from './pages/hairstyle-women-quiz/hairstyle-women-would-try';
import HairstyleWomenStylingProducts from './pages/hairstyle-women-quiz/hairstyle-women-styling-products';
import HairstyleWomenHasBarber from './pages/hairstyle-women-quiz/hairstyle-women-has-barber';
import HairstyleWomenBarberStruggle from './pages/hairstyle-women-quiz/hairstyle-women-barber-struggle';
import HairstyleWomenInfo from './pages/hairstyle-women-quiz/hairstyle-women-info';
import HairstyleWomenHappiestResult from './pages/hairstyle-women-quiz/hairstyle-women-happiest-result';
import HairstyleWomenPhotoRules from './pages/hairstyle-women-quiz/hairstyle-women-photo-rules';
import HairstyleWomenPhoto from './pages/hairstyle-women-quiz/hairstyle-women-photo';
import HairstyleWomenAnalysis from './pages/hairstyle-women-quiz/hairstyle-women-analysis';
import HairstyleWomenBeforeAfter from './pages/hairstyle-women-quiz/hairstyle-women-before-after';
import HairstyleWomenPaywall from './pages/hairstyle-women-quiz/hairstyle-women-paywall';
import HairstyleWomenSuccess from './pages/hairstyle-women-quiz/hairstyle-women-success';

/**
 * Hairstyle funnels, in flow order. The live flow comes from remote config
 * (routeGroups); these are the canonical orders to paste there, and what the
 * funnels were built against.
 */
export const HAIRSTYLE_FLOW = [
  'hairstyle-hero',
  'hairstyle-wonder',
  'hairstyle-holding-back',
  'hairstyle-improve',
  'hairstyle-value',
  'hairstyle-style-like',
  'hairstyle-face-shape',
  'hairstyle-hair-texture',
  'hairstyle-hair-color',
  'hairstyle-social-proof',
  'hairstyle-styling-effort',
  'hairstyle-hair-thickness',
  'hairstyle-wash-frequency',
  'hairstyle-change-frequency',
  'hairstyle-would-try',
  'hairstyle-styling-products',
  'hairstyle-has-barber',
  'hairstyle-barber-struggle',
  'hairstyle-info',
  'hairstyle-happiest-result',
  'hairstyle-photo-rules',
  'hairstyle-photo',
  'hairstyle-analysis',
  'hairstyle-before-after',
  'hairstyle-paywall',
  // email-after-payment sits between the paywall and the upsale when the
  // deferred-email flag is on — the paywall routes to it itself.
  'hairstyle-upsale',
  'hairstyle-success',
];

export const HAIRSTYLE_WOMEN_FLOW = [
  'hairstyle-women-hero',
  'hairstyle-women-wonder',
  'hairstyle-women-holding-back',
  'hairstyle-women-improve',
  'hairstyle-women-value',
  'hairstyle-women-style-like',
  'hairstyle-women-face-shape',
  'hairstyle-women-hair-texture',
  'hairstyle-women-hair-color',
  'hairstyle-women-social-proof',
  'hairstyle-women-styling-effort',
  'hairstyle-women-hair-thickness',
  'hairstyle-women-wash-frequency',
  'hairstyle-women-change-frequency',
  'hairstyle-women-would-try',
  'hairstyle-women-styling-products',
  'hairstyle-women-has-barber',
  'hairstyle-women-barber-struggle',
  'hairstyle-women-info',
  'hairstyle-women-happiest-result',
  'hairstyle-women-photo-rules',
  'hairstyle-women-photo',
  'hairstyle-women-analysis',
  'hairstyle-women-before-after',
  'hairstyle-women-paywall',
  'hairstyle-women-success',
];

/**
 * Fallback flow, used only while remote config has not answered yet, or when
 * routeGroups comes back empty. Whenever routeGroups has pages, it wins.
 */
export const backupFlow = HAIRSTYLE_FLOW;

export const components = {
    "activity-plan": ActivityPlan,
    "barriers": Barriers,
    "analyzing-activity": AnalyzingActivity,
    "analyzing-body": AnalyzingBody,
    "analyzing": Analyzing,
    "analyzing-2": AnalyzingSecond,
    "analyzing-3": AnalyzingThird,
    "analyzing-4": AnalyzingFourth,
    "weight-change": WeightChange,
    "best-app": BestApp,
    "email-2": EmailSecond,
    "preland": PrelandPage,
    "gender": GenderPage,
    'birth-date': BirthDatePage,
    "born": BornPage,
    "name": NamePage,
    "height": HeightPage,
    "weight": WeightPage,
    "analyze-body": AnalyzeBodyPage,
    "full-body-photo": FullBodyPhotoPage,
    "transition-1": TransitionFirst,
    "additional-goals": AdditionalGoalsPage,
    "when": WhenPage,
    "email": EmailPage,
    "email-after-payment": EmailAfterPaymentPage,
    "transition-2": TransitionSecond,
    "before-after": BeforeAfterPage,
    "lts-photo-example": LtsvPhotoExamplePage,
    "face-scan": FaceScanPhoto,
    "face-scan-animation": FaceScanAnimation,
    "face-scan-id": FaceScanId,
    "transition-3": TransitionThird,
    "transition-4": TransitionFourth,
    "transition-5": TransitionFifth,
    "transition-6": TransitionSixth,
    "transition-7": TransitionSeventh,
    "transition-8": TransitionEighth,
    "take-pictures": TakePicturesPage,
    "almost-done": AlmostDonePage,
    "lts-result": LtsResultPage,
    "personal-plan-2": PersonalPlanSecond,
    "personal-plan-3": PersonalPlanThird,
    "personal-plan-4": PersonalPlanFourth,
    "personal-plan-metabolism": PersonalPlanMetabolism,
    'analyzing-answers': AnalyzingAnswersPage,
    "trial-price": TrialPricePage,
    "personal-plan": PersonalPlanPage,
    "personal-plan-dynamic": PersonalPlanDynamic,
    "paywall": PaywallPage,
    "web-upsale-1": WebUpsaleFirst,
    'web-upsale-3': WebUpsaleThird,
    'web-upsale-4': WebUpsaleFourth,
    'web-upsale-5': WebUpsaleFifth,
    'upsale-without-trial': UpsaleWithoutTrial,
    'upsale-nutrition-bundle': UpsaleNutritionBundle,
    'upsale-dynamic': UpsaleDynamic,
    'terms-of-use': TermsOfUse,
    'privacy-policy': PrivacyPolicy,
    //hairstyle-quiz
    "hairstyle-hero": HairstyleHero,
    "hairstyle-wonder": HairstyleWonder,
    "hairstyle-holding-back": HairstyleHoldingBack,
    "hairstyle-improve": HairstyleImprove,
    "hairstyle-value": HairstyleValue,
    "hairstyle-style-like": HairstyleStyleLike,
    "hairstyle-face-shape": HairstyleFaceShape,
    "hairstyle-hair-texture": HairstyleHairTexture,
    "hairstyle-hair-color": HairstyleHairColor,
    "hairstyle-social-proof": HairstyleSocialProof,
    "hairstyle-styling-effort": HairstyleStylingEffort,
    "hairstyle-hair-thickness": HairstyleHairThickness,
    "hairstyle-wash-frequency": HairstyleWashFrequency,
    "hairstyle-change-frequency": HairstyleChangeFrequency,
    "hairstyle-would-try": HairstyleWouldTry,
    "hairstyle-styling-products": HairstyleStylingProducts,
    "hairstyle-has-barber": HairstyleHasBarber,
    "hairstyle-barber-struggle": HairstyleBarberStruggle,
    "hairstyle-info": HairstyleInfo,
    "hairstyle-happiest-result": HairstyleHappiestResult,
    "hairstyle-photo-rules": HairstylePhotoRules,
    "hairstyle-photo": HairstylePhoto,
    "hairstyle-analysis": HairstyleAnalysis,
    "hairstyle-before-after": HairstyleBeforeAfter,
    "hairstyle-paywall": HairstylePaywall,
    "hairstyle-success": HairstyleSuccess,
    "hairstyle-upsale": HairstyleUpsale,

    //hairstyle-women-quiz
    "hairstyle-women-hero": HairstyleWomenHero,
    "hairstyle-women-wonder": HairstyleWomenWonder,
    "hairstyle-women-holding-back": HairstyleWomenHoldingBack,
    "hairstyle-women-improve": HairstyleWomenImprove,
    "hairstyle-women-value": HairstyleWomenValue,
    "hairstyle-women-style-like": HairstyleWomenStyleLike,
    "hairstyle-women-face-shape": HairstyleWomenFaceShape,
    "hairstyle-women-hair-texture": HairstyleWomenHairTexture,
    "hairstyle-women-hair-color": HairstyleWomenHairColor,
    "hairstyle-women-social-proof": HairstyleWomenSocialProof,
    "hairstyle-women-styling-effort": HairstyleWomenStylingEffort,
    "hairstyle-women-hair-thickness": HairstyleWomenHairThickness,
    "hairstyle-women-wash-frequency": HairstyleWomenWashFrequency,
    "hairstyle-women-change-frequency": HairstyleWomenChangeFrequency,
    "hairstyle-women-would-try": HairstyleWomenWouldTry,
    "hairstyle-women-styling-products": HairstyleWomenStylingProducts,
    "hairstyle-women-has-barber": HairstyleWomenHasBarber,
    "hairstyle-women-barber-struggle": HairstyleWomenBarberStruggle,
    "hairstyle-women-info": HairstyleWomenInfo,
    "hairstyle-women-happiest-result": HairstyleWomenHappiestResult,
    "hairstyle-women-photo-rules": HairstyleWomenPhotoRules,
    "hairstyle-women-photo": HairstyleWomenPhoto,
    "hairstyle-women-analysis": HairstyleWomenAnalysis,
    "hairstyle-women-before-after": HairstyleWomenBeforeAfter,
    "hairstyle-women-paywall": HairstyleWomenPaywall,
    "hairstyle-women-success": HairstyleWomenSuccess,

}

export const layouts = {
    MainLayout,
    LegalLayout,
    TransitionLayout,
    LtsLayout,
    HairstyleLayout,
    HairstyleWomenLayout,
}

export const transitionPages = [
  'transition-1',
  'transition-2',
  'transition-3',
  'transition-4',
  'transition-5',
  'transition-6',
  'transition-7',
  'transition-8'
];
